import styled from "@emotion/styled";

export const VideoPreviewContainer = styled.div<{ bottomPanelHeight: number }>`
  display: flex;
  width: 100%;
  flex: 1;
  align-items: center; /* Center for desktop */
  justify-content: center;
  padding: 0px 20px;

  @media (max-width: 768px) {
    padding: 0px;
    align-items: flex-start; /* Top-align for mobile */
    flex: 0 1 auto;
  }
`;

export const VideoContainer = styled.div<{
  aspectRatio?: number;
  bottomPanelHeight: number;
}>`
  aspect-ratio: ${(props) => props.aspectRatio || 16 / 9};
  height: 100%;
  max-height: calc(100vh - 200px);
  overflow: hidden;
  border-radius: 0rem;
  position: relative;

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    border-radius: 0;
    max-height: ${(props) => `calc(100vh - ${props.bottomPanelHeight + 0}px)`};
    /* Add a small margin to prevent any gap appearance */
    margin-bottom: 0;
    @supports (-webkit-touch-callout: none) {
      width: auto;
      height: 100dvh;
      padding-bottom: 80px;
    }
  }
`;

export const InnerVideoPreviewContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    /* Remove any potential spacing that might create gaps */
    margin: 0;
    padding: 0;
  }
`;
